<template>
    <div id="content4">
        <div class="newRow1 newRowColBasic">
            <!-- 5次 -->
            <div class="newRow1Col" v-for="(news,i) in content4row1list" :key="news.id">
                <router-link class="newRow1ColTitleBG" :to="{ name: 'news', params: { id: news.id }}" target="_blank"><p>{{news.title}}</p></router-link>
                <div>
                    <router-link :to="{ name: 'news', params: { id: news.id }}" target="_blank"><img :src="news.pic" alt="" loading="lazy"></router-link>
                    <p>{{a[i + 4]}}</p>
                </div>
            </div>
        </div>
        
        <div class="newRow2 newRowColBasic">
            <div class="latestNew">
                <router-link :to="{ name: 'news', params: { id: newsList[0]['id'] }}" target="_blank">
                    <img v-if="newsList[0]['pic']" :src="newsList[0]['pic']" alt="" style="width:300px;height:220px;object-fit:cover;">
                    <img v-else src='/images/web_img/volunteer-care.jpg' alt="" style="width:300px;height:220px;object-fit:cover;">
                </router-link>
                
                <router-link :to="{ name: 'news', params: { id: newsList[0]['id'] }}" target="_blank"><p>{{newsList[0]['title']}}</p></router-link>
                <p>{{a[0]}}</p>
            </div>
            
            <div class="newNews" v-for="(news1,ii) in content4row2list" v-bind:key='news1.id'>
                <router-link :to="{ name: 'news', params: { id: news1.id }}" target="_blank"><p>{{news1.title}}</p></router-link>
                <div>
                    <router-link :to="{ name: 'news', params: { id: news1.id }}" target="_blank"><img :src="news1.pic" alt="" loading="lazy"></router-link>
                    <p>{{a[ii + 1]}}</p>
                </div>
            </div>

            <img src='/images/web_img/water.jpg' alt="" loading="lazy">
        </div>

        <div class="newRow3 newRowColBasic" >
            <div class="newRow3col1" v-for="(news2,iii) in content4row3list" :key="news2.id">
                <router-link :to="{ name: 'news', params: { id: news2.id }}" target="_blank"><img :src="news2.pic" alt="" loading="lazy"></router-link>
                <div>
                    <router-link :to="{ name: 'news', params: { id: news2.id  }}" target="_blank"><p>{{news2.title}}</p></router-link>
                    <p>{{a[iii + 9]}}</p>
                </div>
            </div>

            <div class="searchBox"> </div>

            <img src='/images/web_img/kids-reading.jpg' alt="" loading="lazy">
            <img src='/images/web_img/lotus.jpg' alt="" loading="lazy">
            
            <div class="newRow3col2" v-for="(news,i) in content4row33list" :key="news.id">
                <router-link :to="{ name: 'news', params: { id: news.id }}" target="_blank"><p>{{news.title}}</p></router-link>
                <p>{{a[i+11]}}</p>
            </div>
        </div> 

        <div class="newRow4 newRowColBasic">
            <img src='/images/web_img/hbl11_blue.jpg' alt="" loading="lazy">
            <!-- 7次 -->
            <div v-for="(news) in content4row4list" :key="news.id">
                <router-link :to="{ name: 'news', params: { id: news.id }}" target="_blank"><img :src="news.pic" alt="" loading="lazy"></router-link>
                <p>{{news.title}}</p>
            </div>
            
        </div>
    </div>
</template>

<script>
import { request } from '@/api/http';

export default {
    data () {
        return {
            //news栏
            newsList : [
                { "author": "","content": "","id": -1, "locked": -1,"pic": "","time": "","title": "","type": -1 },
            ],
            a:[],
            content4row1list:[],
            content4row2list:[],
            content4row3list:[],
            content4row32list:[],
            content4row33list:[],
            content4row4list:[],
        }
    },
    
    mounted(){
        this.getdata();
    },
    methods: {
        getdata(){
            request('/CalawaEnServlet/NewsServlet', { type: 'getAllNewsForUnLocked' })
            .then(res=> {
                this.newsList = res.data;
            })
            .catch(error=> {
                console.log(error);
            });
        },

    },
    watch:{
        newsList:function(){
            // eslint-disable-next-line
            // console.log(this.newsList[0]['content']);

            for(let i = 0;i < this.newsList.length; i++){
                this.a[i] = this.newsList[i]['content'].replace('<p>','');
                this.a[i] = this.a[i].replace('</p>','');
                this.a[i] = this.a[i].replace('<p>','');
                //this.a[i] = this.a[i].replace('&nbsp;&nbsp;','').slice(3,100);
            }
            // for(let i = 0;i < 21; i++){
            //     this.a[i] = '' + this.a[i];
            // }
            // eslint-disable-next-line
            // console.log(this.a);
          //content4row2list
          if(this.newsList.length>1){
            this.content4row2list.push(this.newsList[1]);
          }
          if(this.newsList.length>2){
            this.content4row2list.push(this.newsList[2]);
          }
          if(this.newsList.length>3){
            this.content4row2list.push(this.newsList[3]);
          }
          //content4row1list
          if(this.newsList.length>4){
            this.content4row1list.push(this.newsList[4]);
          }
          if(this.newsList.length>5){
            this.content4row1list.push(this.newsList[5]);
          }
          if(this.newsList.length>6){
            this.content4row1list.push(this.newsList[6]);
          }
          if(this.newsList.length>7){
            this.content4row1list.push(this.newsList[7]);
          }
          if(this.newsList.length>8){
            this.content4row1list.push(this.newsList[8]);
          }
          //content4row3list
          if(this.newsList.length>9){
            this.content4row3list.push(this.newsList[9]);
          }
          if(this.newsList.length>10){
            this.content4row3list.push(this.newsList[10]);
          }
          //content4row32list
          if(this.newsList.length>11){
            this.content4row32list.push(this.newsList[11]);
          }
          //content4row33list
          if(this.newsList.length>12){
            this.content4row33list.push(this.newsList[12]);
          }
          if(this.newsList.length>13){
            this.content4row33list.push(this.newsList[13]);
          }
          //content4row4list
          if(this.newsList.length>13){
            for(let i = 1;i < this.newsList.length-13; i++){
              this.content4row4list.push(this.newsList[13+i]);
            }
            //this.content4row4list.push(this.newsList[14],this.newsList[15],this.newsList[16],this.newsList[17],this.newsList[18],this.newsList[19],this.newsList[20]);
          }




            
            // eslint-disable-next-line
            // console.log(this.content4row4list);

        },
    }
}
</script>

<style lang="scss" scoped>
@mixin manyLine($v){
    overflow: hidden;  
    text-overflow: ellipsis;  
    display: -webkit-box;  
    -webkit-line-clamp: $v;  
    -webkit-box-orient: vertical;  
}

#content4{
    width: 1000px;
    height:820px;

    margin-top: 5px;
    
    .newRowColBasic{
        height: 820px;

        margin:0 3px 0 3px;

        // background-color: aquamarine;
        
        float:left;
    }
    
    .newRow1{
        width: 250px;
        margin-left: 0;

        background-color: white;

        .newRow1Col{
            width: 250px;
            height: 164px;
            .newRow1ColTitleBG{
                width: 250px;
                height: 27px;
                display: inline-block;
                
                background: url(../../assets/leftpart/content2/hongse.jpg) no-repeat center;
                background-size: 250px 27px;                            
                color: white;
                
                padding-top: 3px;
            }
            div{
                width:250px;
                height: 114px;

                padding-top: 20px;
                margin: 0;

                a{
                    img{
                        width: 100px;
                        height: 100px;

                        float: left;
                    }
                }
                p{
                    width: 127px;
                    height: 105px;
                    margin-left: 20px;

                    float: left;
                    
                    font-size: 13px;
                    text-align: left;

                    @include manyLine(6); 

                    text-indent:2em;
                }
            }
        }
    }

    .newRow2{
        width: 300px;
        
        background-color: #e4e4e4;

        padding: 0 15px 0 15px;

        .latestNew{
            a:nth-child(1){
                width: 300px;
                height: 220px;
                display: inline-block;

                margin-top:20px;
                img{
                    width: 300px;
                    height:220px;

                    // padding-top: 20px;
                    margin-top:0;
                }
            }
            a:nth-child(2){
                width: 300px;
                height: 45px;
                display:inline-block;

                background: url(../../assets/leftpart/content4/row2/hbl00-blue.jpg) no-repeat center;
                background-size: 300px 45px;                      

                p:nth-child(1){
                    height: 37px;

                    margin:0px 40px 0 40px;

                    font-size: 20px;
                    padding-top: 5px;
                    text-align: center;

                    color: white;

                    text-overflow:clip;
                    overflow: hidden;
                    white-space:nowrap; 
                }
            }


            p:nth-child(3){
                height: 51px;
                margin-top:10px;

                font-size: 13px;
                text-align: left;

                @include manyLine(3);

                text-indent:2em;
            }
        }
        .newNews{
            width: 300px;
            height: 105px;

            margin-top: 10px;
            a:nth-child(1){
                display: inline-block;
                color: black;
                p{
                    text-align: center;
                    font-size: 16px;
                }
            }

            div:nth-child(2){
                height:75px;
                padding: 5px 0 0 0;
                a{
                    display: block;
                    margin-top: 0;
                    
                    float: left;
                    img{
                        width:90px;
                        height: 70px;

                        margin-top: 0;
                    }
                }
                p{
                    width: 200px;
                    height: 70px;

                    float: left;
                    margin-left: 10px;

                    font-size: 13px;
                    text-align: left;

                    @include manyLine(4);

                    text-indent:2em;
                }
            }
        }
        img:last-child{
            width: 300px;
            margin-top:20px;
        }

    }

    .newRow3{
        width: 300px;

        .newRow3col1{
            height: 105px;

            margin-bottom: 20px;
            
            a{
                img{
                    width:75px;
                    height:105px;
                    float:left;

                    margin: 0 10px 0 10px;
                }   
            }

            div:nth-child(2){
                width: 190px;
                float:left;

                a{
                    p:nth-child(1){
                        width: 190px;
                        height:25px;

                        font-size: 15px;
                        font-weight: 600;

                        background: url(../../assets/leftpart/content2/hongse.jpg) no-repeat center;
                        background-size: 190px 25px;                                       
                        color: white;

                        padding-top: 5px;
                    }
                }

                p:nth-child(2){
                    font-size: 13px;
                    margin-top:8px;

                    @include manyLine(4);

                    text-indent:2em;
                }
            }
        }

        .searchBox{
            width: 300px;
            height:50px;

            margin: 20px 0 10px 0;  

            background-color: #ddd;
        }

        img{
            width: 300px;
            margin-bottom: 10px;
        }

        .newRow3col2{
            width: 300px;
            height: 130px;
            margin-bottom: 20px;
            a{
                p:nth-child(1){
                    width: 300px;
                    height: 30px;

                    font-size: 15px;

                    background: url(../../assets/leftpart/content2/hongse.jpg) no-repeat center;
                    background-size: 300px 30px;
                    color: white;

                    padding-top: 5px;
                }
            }
            p:nth-child(2){
                width: 300px;
                height: 80px;

                font-size: 13px;
                text-align: left;

                margin:10px 0 0 0px;

                @include manyLine(4);

                text-indent:2em;
            }
        }
    }

    .newRow4{
        width: 100px;
        margin: 0 0 0 5px;

        background-color: #e4e4e4;

        div{
            margin-top:17px;
            a{
                img{    
                    width:100px;
                    height: 70px;
                }                               
            }

            p{
                width:100px;
                height:20px;
                font-size: 13px;

                white-space:nowrap; 
                overflow:hidden; 
                text-overflow:ellipsis;
            }                 
        }

    }
}
</style>
